import { VideoPageheader } from '@shared/Frontend/components/pageheader'
import { StyleguideExample, StyleguidePart } from '@shared/Hoppinger.Styleguide/Frontend'
import * as React from 'react'
import { dummyData } from '../../config/dummyData'

export const ComponentsPageheader = () => (
  <>
    <StyleguidePart title="Video / Homepage" intro="The KPI icons can be selected from a dropdown in the CMS.">
      <StyleguideExample showExampleLabel={false} isFullScreen={true}>
        <ComponentVideoPageheader />
      </StyleguideExample>
    </StyleguidePart>
  </>
)

export const ComponentVideoPageheader = () => {
  return (
    <VideoPageheader
      poster={dummyData.image}
      title="A better world through Marine ingenuity"
      primaryUpdater={{...dummyData.primaryUpdater, title: 'Discover how'}}
      kpis={[
        { text: 'Over 198 projects in 43 countries', icon: 'Icon_driver Sustainable cities and communities'},
        { text: '155 years of expertise as a marine contractor', icon: 'Icon_cutter suction dredger'},
        { text: '84 nationalities of ingenious people', icon: 'Icon_personnel.svg'},
      ]}
      viewportWidth={window.innerWidth}
    />
  )
}
